module.exports = __webpack_public_path__ + "img/Somaliland.bd749145.png";